import React from "react";
import { Container } from "react-bootstrap";
import { ContainerType } from "../Models/Enum";
import { IMAGE_MAIN_ENDPOINT } from "../constant";

function FruitTrail({ data }) {

    var TrailImg =  data.data.ContentJson.FLD_0_3_47_47;
    var TrailHeading = data.data.ContentJson.FLD_0_1_54_54


    return (
        <div className='row fruitTrailOuter' >
            <div className='col p-0'>
                <div className='row fruitTrailInner img-fluid w-100 position-relative g-0' style={{  backgroundImage: `url('../../../server-build/Images/MapBackgroung1.png')` }}  >
                    <div className='col'>
                        <h2 className='text-center mt-0 mt-lg-5 pb-3 mb-0 pb-lg-0 pt-3 pt-lg-0 text-white'>{TrailHeading}</h2>
                    </div>
                    <Container className="position-absolute d-none d-lg-block" style={{ top: '138px' }} >
                        <div className='row justify-content-center align-items-center '>
                            <div className='col-auto'>
                                <img
                                    className='img-fluid'
                                    src={IMAGE_MAIN_ENDPOINT + TrailImg}
                                    alt='Mango Trail'

                                />
                            </div>
                        </div>
                    </Container>

                    <div className="container-fluid d-lg-none">
                        <div className="row">
                            
                                <div className='col-auto p-0'>
                                    <img
                                        className='img-fluid'
                                        src={IMAGE_MAIN_ENDPOINT+TrailImg}
                                        alt='Fruit Trail'

                                    />
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FruitTrail;